

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { NotificationModel } from 'src/app/features/notifications-center/notifications';
import { NotificationsService } from 'src/app/features/notifications-center/notifications.service';
import { ApiError, ApiErrorType } from 'src/app/model/global-interface';
import { LocalStorageService } from 'src/app/services/local-storage.service';

export interface Toast {
  id: string;
  message: string;
  type: 'success' | 'error' | 'warning' | 'info';
  duration?: number;
  closable?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private toastsSubject = new BehaviorSubject<Toast[]>([]);
  public toasts$ = this.toastsSubject.asObservable();

  private generateId(): string {
    return Math.random().toString(36).substr(2, 9);
  }

  constructor(private notifS: NotificationsService,private localStorageService: LocalStorageService, private router: Router) { }


  show(message: string, type: 'success' | 'error' | 'warning' | 'info' = 'info', duration: number = 5000, closable: boolean = true): string {
    const toast: Toast = {
      id: this.generateId(),
      message,
      type,
      duration,
      closable
    };

    const currentToasts = this.toastsSubject.value;
    this.toastsSubject.next([...currentToasts, toast]);
    let user = this.localStorageService.getUserData();
      let notif: NotificationModel = {
            content: '',
            title: message,
            location: this.router.url.replace('/','').replaceAll('/',' > ').replaceAll(';',' | '),
            date: Date.now().toString(),
            userId: user!.id,
            severity: type,
            viewed: false
          }
          
    this.notifS.writeNotificationApp(notif);

    // Auto-remove dopo la durata specificata
    if (duration > 0) {
      setTimeout(() => {
        this.remove(toast.id);
      }, duration);
    }else{
      setTimeout(() => {
        this.remove(toast.id);
      }, 1500);
    }

    return toast.id;
  }

  success(message: string, duration: number = 1500, closable: boolean = true): string {
    return this.show(message, 'success', duration, closable);
  }

  error(message: string, duration: number = 3000, closable: boolean = true): string {
    return this.show(message, 'error', duration, closable);
  }

  warning(message: string, duration: number = 3000, closable: boolean = true): string {
    return this.show(message, 'warning', duration, closable);
  }

  info(message: string, duration: number = 3000, closable: boolean = true): string {
    return this.show(message, 'info', duration, closable);
  }

  remove(id: string): void {
    const currentToasts = this.toastsSubject.value;
    const filteredToasts = currentToasts.filter(toast => toast.id !== id);
    this.toastsSubject.next(filteredToasts);
  }

  clear(): void {
    this.toastsSubject.next([]);
  }

  /**
   * Automatic handling of errors
   * 
   */
   handleApiError(error: ApiError): void {
    switch (error.type) {
      case ApiErrorType.BadRequest:
        this.error('Richiesta non valida: ' + error.message);
        break;
        
      case ApiErrorType.Unauthorized:
        this.error('Accesso non autorizzato');
        //this.router.navigate(['/login']);
        break;
        
      case ApiErrorType.Forbidden:
        this.error('Accesso negato: non hai i permessi necessari');
        break;
        
      case ApiErrorType.NotFound:
        this.error('Risorsa non trovata');
        break;
        
      case ApiErrorType.Conflict:
        this.error('Conflitto: ' + error.message);
        break;
        
      case ApiErrorType.Unprocessable:
        this.error('Dati non processabili: ' + error.message);
        break;
        
      default:
        this.error(error.message);
    }
  }
}